class EdenPurchaseSelector extends HTMLElement {
  connectedCallback() {
    this.choiceInputs = Array.from(this.querySelectorAll('[data-eden-purchase-choice]'));
    this.planInputs = Array.from(this.querySelectorAll('[data-eden-plan-choice]'));
    this.variantInput = this.querySelector('[data-eden-variant-input]');
    this.sellingPlanInput = this.querySelector('[data-eden-selling-plan-input]');
    this.frequencyGroup = this.querySelector('[data-eden-frequency-group]');
    this.quantityInput = this.querySelector('[data-eden-quantity]');
    this.submitButton = this.querySelector('[data-eden-submit]');
    this.submitText = this.querySelector('[data-eden-submit-text]');
    this.status = this.querySelector('[data-eden-selection-status]');

    if (!this.variantInput || !this.sellingPlanInput || !this.submitButton) return;

    this.choiceInputs.forEach((input) => input.addEventListener('change', () => this.syncSelection()));
    this.planInputs.forEach((input) => input.addEventListener('change', () => this.syncSelection()));
    this.syncSelection();
  }

  syncSelection() {
    const selectedChoice = this.choiceInputs.find((input) => input.checked && !input.disabled);
    const isSubscription = selectedChoice?.value === 'subscription';

    this.planInputs.forEach((input) => {
      input.disabled = !isSubscription;
    });

    if (this.frequencyGroup) {
      this.frequencyGroup.setAttribute('aria-disabled', isSubscription ? 'false' : 'true');
    }

    if (isSubscription && !this.planInputs.some((input) => input.checked)) {
      const firstPlan = this.planInputs.find((input) => !input.disabled);
      if (firstPlan) firstPlan.checked = true;
    }

    const selectedPlan = isSubscription ? this.planInputs.find((input) => input.checked && !input.disabled) : null;
    this.variantInput.value = selectedChoice?.dataset.variantId || '';
    this.sellingPlanInput.value = selectedPlan?.value || '';
    this.sellingPlanInput.disabled = !isSubscription || !selectedPlan;

    const isTrial = selectedChoice?.value === 'trial';
    if (this.quantityInput) {
      if (isTrial) {
        this.quantityInput.max = '1';
        this.quantityInput.value = '1';
      } else {
        this.quantityInput.removeAttribute('max');
      }
    }

    const selectionComplete = Boolean(selectedChoice) && (!isSubscription || Boolean(selectedPlan));
    this.submitButton.disabled = !selectionComplete;
    if (this.submitText) this.submitText.textContent = selectionComplete ? 'Add selection to cart' : 'Choose an option';

    if (this.status) {
      if (!selectedChoice) {
        this.status.textContent = 'Choose one of the three purchase options.';
      } else if (isSubscription && selectedPlan) {
        const planLabel = this.querySelector(`label[for="${CSS.escape(selectedPlan.id)}"] strong`)?.textContent?.trim();
        this.status.textContent = `Subscription selected${planLabel ? `: ${planLabel}` : ''}.`;
      } else if (isTrial) {
        this.status.textContent = 'Try one bag selected. Quantity is limited to one bag.';
      } else {
        this.status.textContent = 'Pay the full price selected.';
      }
    }
  }
}

if (!customElements.get('eden-purchase-selector')) {
  customElements.define('eden-purchase-selector', EdenPurchaseSelector);
}
